import * as R from 'ramda'

/** True when any of `fields` carries a react-hook-form error. An rhf error
 *  sits at the field's own path (`errors.a.b` for `a.b`), so each path is
 *  probed directly rather than flattening the error tree. */
export const hasFieldErrors = (
  fields: string[] | undefined,
  errors: object,
): boolean =>
  !!fields?.length &&
  R.any((field: string) => !!R.path(field.split('.'), errors), fields)
